export default "__VITE_ASSET__JZjC65AQ__"